module.exports = __webpack_public_path__ + "img/SKLB-Bienvenido.d4bdf185.png";